type Props = {
  count?: number;
};

export function FacilityCardSkeleton({ count = 5 }: Props) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="border border-neut-200 rounded-lg p-4 animate-pulse"
        >
          <div className="h-4 bg-neut-100 rounded w-1/4 mb-2" />
          <div className="h-3 bg-neut-100 rounded w-1/2" />
        </div>
      ))}
    </div>
  );
}
